import { useSelector, useDispatch } from 'react-redux'
import dayjs from 'dayjs'

import { ModalForm } from 'components/common'
import NewsPostApi, { pkField, getDetailUrl } from 'models/NewsPost/api'
import { NewsPostActions } from 'models/NewsPost/slice'
import MainFieldSet from './MainFieldSet'


const NewsPostForm = ({ mode = "list", initials }) => {
  const { activeForm, formDetailPK } = useSelector(state => state.newsPost);

  const [apiGetFormDetail, apiGetFormDetailProps] = NewsPostApi.endpoints.getNewsPostFormDetail.useLazyQuery();
  const [apiUpdate, apiUpdateProps] = NewsPostApi.endpoints.updateNewsPost.useMutation();

  const dispatch = useDispatch();

  const formDetail = apiGetFormDetailProps.data;

  const onFinish = (values) => {
    apiUpdate(values);
  };

  return (
    <ModalForm
      name="NewsPost"
      withTabs={false}
      title={formDetailPK ? `Новость «${formDetail?.title}»`: 'Новая новость'}
      width={700}
      mode={mode}
      visible={activeForm === 'editForm'}

      pkField={pkField}
      formDetailPK={formDetailPK}

      getDetailUrl={getDetailUrl}
      apiGetFormDetail={apiGetFormDetail}
      apiGetFormDetailProps={apiGetFormDetailProps}
      apiUpdateProps={apiUpdateProps}
      api={NewsPostApi}

      onFinish={onFinish}
      onClose={() => dispatch(NewsPostActions.closeForm())}
      initialValues={{
        sort: 100,
        ...initials
      }}

      prepareFormValues={(detail) => {
        return { ...detail, date: dayjs(detail.date) }
      }}
    >
      <MainFieldSet />
    </ModalForm>
  );
}


export default NewsPostForm
